export default __webpack_public_path__ + "static/media/Bilhetagem Real Size.75073b8f.svg";